export const mapillaryCoverageDateString = 'Mai 2025'
